import { css, StyleDeclarationValue } from 'aphrodite';
import * as React from 'react';
import { Route, Switch, useHistory, useRouteMatch } from 'react-router-dom';
import { SURVEY_TYPES } from '../../../extViewmodels';
import { useEventLogging } from '../../../models/Logging';
import { useErrorMessagesContext } from '../../components/ErrorModalProvider/context';
import { DonationSurvey } from '../../components/surveys/DonationSurvey/index';
import { IDonationSurvey, IOperationResultNoValue } from '../../models/Api';
import { useSurvey } from '../../models/hooks';
import { Survey } from '../SurveyResponses/shared/Survey';
import { styleSheet } from './styles';

interface IProps {
	className?: string;
	styles?: StyleDeclarationValue[];
}

export const DonationSurveyContainer: React.FC<IProps> = props => {
	const { className, styles = [] } = props;
	const { params: urlParams = {}, path: matchPath } = useRouteMatch<{
		token?: string;
	}>();
	const history = useHistory();
	const { logApiError } = useEventLogging('DonationSurveyContainer');
	const { pushError } = useErrorMessagesContext();

	const { hasAccessToken, isUnavailable, surveyQuery } = useSurvey<IDonationSurvey>({
		accessToken: urlParams.token,
		options: {
			expand: 'options',
		},
		type: SURVEY_TYPES.DonationSurvey,
	});

	React.useEffect(() => {
		if (!hasAccessToken) {
			return;
		}

		if (surveyQuery.error) {
			logApiError('Survey-Error', surveyQuery.error as IOperationResultNoValue);
			pushError(surveyQuery.error);
			return;
		}

		if (surveyQuery.data && isUnavailable) {
			history.push(`${matchPath.toLocaleLowerCase().replace(':token?', 'unavailable')}`);
		}
	}, [history, hasAccessToken, isUnavailable, logApiError, matchPath, pushError, surveyQuery.data, surveyQuery.error]);

	return (
		<Survey
			cardStyles={[styleSheet.surveyContent]}
			className={`donation-survey-container ${className || ''}`}
			styles={[styleSheet.container, ...styles]}
			survey={surveyQuery.data}
			contentStyles={[styleSheet.body]}
		>
			<Switch>
				<Route path={`${matchPath.toLocaleLowerCase().replace(':token?', 'unavailable')}`}>
					<div className={css(styleSheet.unavailable)}>
						<p>This donation survey is not available at this time.</p>
					</div>
				</Route>
				<Route>{surveyQuery?.data && <DonationSurvey survey={surveyQuery?.data} token={urlParams.token} />}</Route>
			</Switch>
		</Survey>
	);
};
